import React from 'react';
import clsx from 'clsx';
//MUI
import {makeStyles} from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';

const useStyles = makeStyles(theme => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      position: 'absolute',
      height: '95%',
      overflow: 'auto',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3)
   },
   full: {
      width: '95%'
   },
   auto: {
      [theme.breakpoints.up('sm')]: {
         width: 'auto'
      }
   }
}));

function FullModal({autoWidth, id, ...props}) {
   const classes = useStyles();
   return (
      <Modal
         id={id}
         open={props.open}
         onClose={props.onClose}
         className={classes.modal}
         aria-labelledby="simple-modal-title"
         aria-describedby="simple-modal-description"
      >
         <Fade in={props.open}>
            <div
               className={clsx(classes.paper, classes.full, {
                  [classes.auto]: autoWidth
               })}
            >
               {props.children}
            </div>
         </Fade>
      </Modal>
   );
}

export default FullModal;
